import Vue from 'vue'
import App from './App.vue'
import './assets/css/base.less'
import http from './http/index.js'

Vue.config.productionTip = false
Vue.prototype.$http = http

import 'vant/lib/index.css';
import { Button, Toast } from 'vant';

Vue.use(Button).use(Toast);
Toast.setDefaultOptions({ overlay: true, });
Toast.setDefaultOptions('loading', { duration: 0 });

new Vue({
  render: h => h(App),
}).$mount('#app')
